<template>
  <div class="app-header">
    <!-- 顶部深红条 -->
    <div class="app-header__top-bar">
      <a
        href="https://www.samr.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        class="app-header__top-link"
      >
        国家市场监督管理总局&nbsp;主管
      </a>
    </div>

    <!-- Logo + 搜索 + 头像 -->
    <div class="app-header__logo-row">
      <img
        class="app-header__logo"
        referrerpolicy="no-referrer"
        :src="logoImage"
        alt="logo"
      />

      <div class="app-header__search" @click="onSearchClick">
        <img
          class="app-header__search-icon"
          referrerpolicy="no-referrer"
          :src="searchIconImage"
          alt="search"
        />
      </div>

      <img
        class="app-header__avatar"
        referrerpolicy="no-referrer"
        :src="avatarImage"
        alt="avatar"
        @click="onAvatarClick"
      />
    </div>

    <!-- 导航栏（可滑动、可点击） -->
    <div class="app-header__nav-wrapper">
      <div class="app-header__nav-scroll" ref="navScroll">
        <span
          v-for="(item, idx) in allNavItems"
          :key="idx"
          :ref="'navItem' + idx"
          class="app-header__nav-item"
          :class="{ 'app-header__nav-item--active': activeNavItem && activeNavItem.id === item.id }"
          :style="getNavItemStyle(item)"
          @click="onNavClick(item, idx)"
        >{{ item.name }}</span>
        <!-- 指示条（在滚动容器内，跟随滑动） -->
        <span
          class="app-header__indicator"
          :style="indicatorStyle"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategory } from '../../../api/category'

export default {
  name: 'AppHeader',
  props: {
    // AppHeader 完全自包含，所有内容在组件内部读取
  },
  data() {
    return {
      logoImage: require('../assets/img/logo.png'),
      searchIconImage: require('../assets/img/FigmaDDSSlicePNG2f1445b1e801217d7ade9344b6d4bd59.png'),
      avatarImage: require('../assets/img/FigmaDDSSlicePNG8f0ef02f658fdd5b0ed0065ce4bcffcd.png'),
      categoryList: [],
      magazineCategoryId: null,
      indicatorLeft: 0,
      indicatorWidth: 0
    };
  },
  computed: {
    allNavItems() {
      return [{ id: 0, name: '首页', color: '' }, ...this.displayNavItems];
    },
    displayNavItems() {
      return this.categoryList;
    },
    activeCategoryId() {
      const route = this.$route;
      if (!route) return null;
      // 电子杂志页面固定选中电子杂志标签
      if (route.path === '/magazine' && this.magazineCategoryId) {
        return Number(this.magazineCategoryId);
      }
      // /channel/index?categoryId=xxx
      if (route.query && route.query.categoryId) {
        return Number(route.query.categoryId);
      }
      // /channel/:categoryId
      if (route.params && route.params.categoryId) {
        return Number(route.params.categoryId);
      }
      return null;
    },
    activeNavItem() {
      if (!this.activeCategoryId) return null;
      return this.allNavItems.find(item => item.id === this.activeCategoryId) || null;
    },
    activeColor() {
      return (this.activeNavItem && this.activeNavItem.color) || '';
    },
    indicatorStyle() {
      return {
        left: `${this.indicatorLeft}px`,
        width: `${this.indicatorWidth}px`,
        backgroundColor: this.activeColor || 'var(--color-primary)'
      };
    }
  },
  mounted() {
    this.loadCategory();
    this.$nextTick(() => {
      this.updateActiveIndicator();
    });
  },
  watch: {
    '$route'() {
      this.$nextTick(() => {
        this.updateActiveIndicator();
      });
    },
    displayNavItems() {
      this.$nextTick(() => {
        this.updateActiveIndicator();
      });
    }
  },
  methods: {
    async loadCategory() {
      try {
        const res = await getCategory();
        const data = res.data || [];
        this.categoryList = data.map(item => ({
          id: item.id,
          name: item.name,
          color: item.color || ''
        }));
        const magazineItem = data.find(item => item.name === '电子杂志');
        this.magazineCategoryId = magazineItem ? magazineItem.id : null;
      } catch (err) {
        console.error('导航分类加载失败:', err);
        this.categoryList = [];
        this.magazineCategoryId = null;
      }
    },
    getNavItemStyle() {
      // 菜单栏不使用动态颜色样式
      return {};
    },
    onNavClick(item, idx) {
      this.updateIndicator(idx);
      if (item.id === 0) {
        this.$router.push('/home');
        return;
      }
      if (item.name === '电子杂志') {
        this.$router.push('/magazine');
        return;
      }
      this.$router.push(`/channel/index?categoryId=${item.id}`);
      this.$emit('nav-click', item);
    },
    onSearchClick() {
      this.$router.push('/search');
    },
    onAvatarClick() {
      this.$router.push('/my');
    },
    updateActiveIndicator() {
      if (!this.activeNavItem) {
        this.indicatorLeft = 0;
        this.indicatorWidth = 0;
        return;
      }
      const idx = this.allNavItems.findIndex(item => item.id === this.activeNavItem.id);
      this.updateIndicator(idx >= 0 ? idx : 0);
      this.scrollToActiveItem(idx >= 0 ? idx : 0);
    },
    scrollToActiveItem(idx) {
      const navScroll = this.$refs.navScroll;
      const refKey = 'navItem' + idx;
      const els = this.$refs[refKey];
      if (!navScroll || !els || !els[0]) return;
      const el = els[0];
      const scrollLeft = el.offsetLeft - (navScroll.clientWidth / 2) + (el.offsetWidth / 2);
      navScroll.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    },
    updateIndicator(idx) {
      const refKey = 'navItem' + idx;
      const els = this.$refs[refKey];
      if (els && els[0]) {
        const el = els[0];
        this.indicatorLeft = el.offsetLeft;
        this.indicatorWidth = el.offsetWidth;
      }
    }
  }
};
</script>

<style scoped>
/* ── 容器 ── */
.app-header {
  width: var(--page-width);
  background-color: var(--color-primary-bg);
  font-size: 0;
  line-height: 0;
}

/* ── 顶部深红条 ── */
.app-header__top-bar {
  background-color: var(--color-primary-deep);
  height: 80px;
  width: var(--page-width);
  display: flex;
  align-items: center;
  padding: 0 var(--space-6);
  box-sizing: border-box;
}

.app-header__top-link {
  color: var(--color-gold);
  font-size: var(--font-lg);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 30px;
  text-decoration: none;
  cursor: pointer;
  text-align: left;
}

.app-header__top-link:hover {
  opacity: 0.8;
}

/* ── Logo 行（Logo + 搜索 + 头像垂直居中对齐） ── */
.app-header__logo-row {
  display: flex;
  align-items: center;
  background-color: var(--color-primary-bg);
  width: var(--page-width);
  height: 130px;
  padding: 0 var(--space-6);
  box-sizing: border-box;
}

.app-header__logo {
  display: block;
  width: 153px;
  height: 60px;
  object-fit: contain;
  flex-shrink: 0;
}

.app-header__search {
  display: flex;
  align-items: center;
  width: 474px;
  height: 60px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: var(--radius-full);
  margin-left: 33px;
  flex-shrink: 0;
}

.app-header__search-icon {
  display: block;
  width: 33px;
  height: 33px;
  margin-left: 15px;
}

.app-header__avatar {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-left: auto;
  flex-shrink: 0;
}

/* ── 导航栏（可滑动） ── */
.app-header__nav-wrapper {
  position: relative;
  width: var(--page-width);
}

.app-header__nav-scroll {
  display: flex;
  align-items: center;
  gap: 0;
  width: var(--page-width);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: 18px 0 9px;
  box-sizing: border-box;
  position: relative;
  background-color: #F1F1F1;
}

.app-header__nav-scroll::-webkit-scrollbar {
  display: none;
}

.app-header__nav-item {
  display: inline-block;
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  white-space: nowrap;
  line-height: 58px;
  padding: 0 20px;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
  transition: color var(--transition-fast);
}

.app-header__nav-item:hover {
  color: var(--color-primary);
}

.app-header__nav-item--active {
  color: var(--color-primary);
  font-weight: var(--weight-bold);
}

/* 红色指示条 */
.app-header__indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  height: var(--space-1);
  background-color: var(--color-primary);
  border-radius: var(--space-5);
  transition: left 0.3s ease, width 0.3s ease;
  pointer-events: none;
}
</style>
